import { useContext } from 'react';
import { AppProviderContext } from 'utils/AppProvider';

export const useAppAPI = () => useContext(AppProviderContext);
